import {Toaster} from 'sonner'

const Toast = () => {
    return <Toaster />
}

export default Toast
